import LocalizedStrings from "react-localization";
import {resource_strings} from "../translations/resource_translations";
import localeHelpers from "./LocaleHelper";
import stringHelpers from "./StringHelper";
import stripeSvg from "assets/img/icons/common/stripe.svg"
import cashSvg from "assets/img/icons/common/wallet.svg"
import ccSvg from "assets/img/icons/common/cc.svg"
import bankSvg from "assets/img/icons/common/bank.svg"
import invoiceSvg from "assets/img/icons/common/invoice.svg"
import freeSvg from "assets/img/icons/common/free.svg"
import ppSvg from "assets/img/icons/common/paypal.svg"
import questionSvg from "assets/img/icons/common/question.svg"
import vippsSvg from "assets/img/icons/common/vippsJKLAhw4xAQ4PNYEXHQmyrgJM0XmBqr7FEt4T.svg"
import wixSvg from "assets/img/icons/common/wix.svg"
import browserSvg from "assets/img/icons/common/browser.svg"

const paymentTypeHelpers = {
    paymentTypes: function() {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        return [
            {value: 'c', label: resourceStrings.payment_methods.cash, icon: cashSvg},
            {value: 'cc', label: resourceStrings.payment_methods.cc, icon: ccSvg},
            {value: 'b', label: resourceStrings.payment_methods.bank, icon: bankSvg},
            {value: 'i', label: resourceStrings.payment_methods.invoice, icon: invoiceSvg},
            {value: 'f', label: resourceStrings.payment_methods.free, icon: freeSvg},
            {value: 's', label: resourceStrings.payment_methods.stripe, icon: stripeSvg},
            {value: 'p', label: resourceStrings.payment_methods.pp, icon: ppSvg},
            {value: 'n', label: resourceStrings.payment_methods.nd, icon: questionSvg},
            {value: 'w', label: "WIX", icon: wixSvg},
            {value: 'web', label: "Web", icon: browserSvg},
            {value: 'red', label: "Redsys", icon: browserSvg},
            {value: 'vipps', label: "Vipps", icon: vippsSvg}
        ];
    },

    defaultPaymentMethod: function () {
        const lup = localStorage.getItem("last_used_pm")
        if (lup && lup.length > 0) {
            const item = this.paymentTypes().find(item => item.value === lup)
            if (item) return item
            else return this.paymentTypes()[0]
        }
        else {
            return this.paymentTypes()[0]
        }
    },

    storeDefaultPaymentMethod: function (pt_value) {
        localStorage.setItem("last_used_pm", pt_value)
    },

    notDefined: function() {
        return this.paymentTypes()[this.paymentTypes().length - 2]
    },

    // INVOICES

    invoiceTypes: function() {
        let resourceStrings = new LocalizedStrings(resource_strings);
        resourceStrings.setLanguage(localeHelpers.currentLocale());

        return [
            {value: 't', label: resourceStrings.tickets},
            {value: 'i', label: stringHelpers.capitalize(resourceStrings.incomes)},
            {value: 'o', label: resourceStrings.categories.other},
        ];
    },

};

export default paymentTypeHelpers;